<ion-list>
  <ion-item *ngIf="!isDefault">
    <ion-label slot="start">
      <h3>Override default</h3>
      <p></p>
    </ion-label>
    <label class="switch" slot="end">
      <input
        type="checkbox"
        [(ngModel)]="overrideAutoresponder"
        (change)="handleChange()"
      />
      <span class="slider"></span>
    </label>
  </ion-item>

  <ng-container *ngIf="overrideAutoresponder">
    <ion-item>
      <ion-label slot="start">
        <h3>Enabled</h3>
        <p></p>
      </ion-label>
      <label class="switch" slot="end">
        <input
          type="checkbox"
          [(ngModel)]="autoresponder.enabled"
          (change)="handleChange()"
        />
        <span class="slider"></span>
      </label>
    </ion-item>
    <div [hidden]="!autoresponder.enabled">
      <ion-list>
        <ion-item>
          <ion-label>
            <h3>When to enable</h3>
          </ion-label>
          <ion-select
            slot="end"
            class="select-outline"
            interface="popover"
            [(ngModel)]="autoresponder.condition"
            (ionChange)="handleChange()"
          >
            <ion-select-option value="always">Always</ion-select-option>
            <ion-select-option value="outside-working-hours"
              >Outside of working hours</ion-select-option
            >
          </ion-select>
        </ion-item>
        <ion-item
          *ngIf="
            isDefault && autoresponder.condition === 'outside-working-hours'
          "
        >
          <ion-label>
            <h3>Working hours</h3>
          </ion-label>
          <ion-button
            slot="end"
            color="dark"
            fill="clear"
            class="button-dark-border"
            (click)="editWorkingHours()"
          >
            Set working hours
          </ion-button>
        </ion-item>
      </ion-list>
      <div class="text-editor-container">
        <app-slack-text-editor
          [content]="autoresponder.message"
          placeholder="Add a message that will be sent to the customer in a thread"
          style="width: 100%"
          [hideStrikethrough]="true"
          [hideCodeblock]="true"
          [hideCode]="true"
          (contentDidChange)="onMessageContentChange($event)"
          [projectId]="projectId ?? undefined"
        >
        </app-slack-text-editor>
      </div>
      <ion-list *ngIf="autoresponder.condition === 'always'" class="no-padding">
        <ion-item>
          <ion-checkbox
            slot="start"
            [(ngModel)]="autoresponder.alternateMessageEnabled"
            (ionChange)="handleChange()"
          ></ion-checkbox>
          <ion-label>
            <h3>Use a different message outside of working hours</h3>
          </ion-label>
        </ion-item>
      </ion-list>
      <div
        class="text-editor-container"
        *ngIf="
          autoresponder.condition === 'always' &&
          autoresponder.alternateMessageEnabled
        "
      >
        <app-slack-text-editor
          [content]="autoresponder.alternateMessage"
          placeholder="Add a message that will be sent to the customer in a thread"
          style="width: 100%"
          [hideStrikethrough]="true"
          [hideCodeblock]="true"
          [hideCode]="true"
          (contentDidChange)="onAlternateMessageContentChange($event)"
          [projectId]="projectId ?? undefined"
        >
        </app-slack-text-editor>
      </div>
      <ion-list
        *ngIf="authService.isAiFeatureEnabled('suggestResponses')"
        class="no-padding"
      >
        <ion-item>
          <ion-checkbox
            slot="start"
            [(ngModel)]="autoresponderAiResponsesEnabled"
            (ionChange)="handleChange()"
          ></ion-checkbox>
          <ion-label>
            <h3>Include AI Generated Responses ✨</h3>
          </ion-label>
          <ion-select
            slot="end"
            interface="popover"
            [(ngModel)]="autoresponderAiResponsesCondition"
            (ionChange)="handleChange()"
            [hidden]="
              !autoresponderAiResponsesEnabled ||
              autoresponder.condition === 'outside-working-hours'
            "
          >
            <ion-select-option value="always">Always</ion-select-option>
            <ion-select-option value="outside-working-hours"
              >Outside of working hours</ion-select-option
            >
          </ion-select>
        </ion-item>

        <div
          *ngIf="autoresponderAiResponsesEnabled"
          class="flex-space-between"
          style="
            margin-left: 24px;
            border-left: 1px solid var(--ion-color-step-50);
            padding-left: 6px;
          "
        >
          <div style="width: 50%">
            <ion-item *ngIf="autoresponderAiResponsesEnabled">
              <ion-checkbox
                slot="start"
                [(ngModel)]="aiResponsePrefixEnabled"
                (ionChange)="handleChange()"
              ></ion-checkbox>
              <ion-label text-wrap>
                <h3>Include a prefixed message when the AI has a response</h3>
              </ion-label>
            </ion-item>
            <div
              class="text-editor-container"
              *ngIf="autoresponderAiResponsesEnabled && aiResponsePrefixEnabled"
            >
              <app-slack-text-editor
                [content]="autoresponder.aiResponsePrefix"
                [placeholder]="
                  'Example: This AI generated response may help in the meantime:'
                "
                style="width: 100%"
                [hideStrikethrough]="true"
                [hideCodeblock]="true"
                [hideCode]="true"
                (contentDidChange)="onPrefixContentChange($event)"
                [projectId]="projectId ?? undefined"
              >
              </app-slack-text-editor>
            </div>
          </div>
          <div style="width: 50%">
            <ion-item *ngIf="autoresponderAiResponsesEnabled">
              <ion-checkbox
                slot="start"
                [(ngModel)]="aiResponseFallbackEnabled"
                (ionChange)="handleChange()"
              ></ion-checkbox>
              <ion-label text-wrap>
                <h3>
                  Include a fallback message when the AI doesn't know the answer
                </h3>
              </ion-label>
            </ion-item>
            <div
              class="text-editor-container"
              *ngIf="
                autoresponderAiResponsesEnabled && aiResponseFallbackEnabled
              "
            >
              <app-slack-text-editor
                [content]="autoresponder.aiResponseFallback"
                [placeholder]="'Example: I\'m not sure about the answer.'"
                style="width: 100%"
                [hideStrikethrough]="true"
                [hideCodeblock]="true"
                [hideCode]="true"
                (contentDidChange)="onFallbackContentChange($event)"
                [projectId]="projectId ?? undefined"
              >
              </app-slack-text-editor>
            </div>
          </div>
        </div>

        <ion-item>
          <ion-checkbox
            slot="start"
            [(ngModel)]="autoresponderKnowledgeBaseEnabled"
            (ionChange)="handleChange()"
          ></ion-checkbox>
          <ion-label>
            <h3>Include AI-Recommended Knowledge Base Articles ✨</h3>
          </ion-label>
          <ion-select
            slot="end"
            interface="popover"
            [(ngModel)]="autoresponderKnowledgeBaseCondition"
            (ionChange)="handleChange()"
            [hidden]="
              !autoresponderKnowledgeBaseEnabled ||
              autoresponder.condition === 'outside-working-hours'
            "
          >
            <ion-select-option value="always">Always</ion-select-option>
            <ion-select-option value="outside-working-hours"
              >Outside of working hours</ion-select-option
            >
          </ion-select>
        </ion-item>
      </ion-list>
      <!-- <ion-list class="no-padding">
        <ion-item>
          <ion-label>
            <h3>Disclaimer message</h3>
            <p>Required disclaimer, automatically posted when autoresponder is enabled</p>
          </ion-label>
        </ion-item>
      </ion-list>
      <div class="text-editor-container">
        <app-slack-text-editor
          [content]="autoresponder.disclaimerMessage"
          placeholder="This channel uses automated responses."
          style="width: 100%"
          [hideStrikethrough]="true"
          [hideCodeblock]="true"
          [hideCode]="true"
          (contentDidChange)="onDisclaimerMessageContentChange($event)"
          [projectId]="projectId ?? undefined"
        >
        </app-slack-text-editor>
      </div> -->
    </div>
  </ng-container>
</ion-list>
